import styled from 'styled-components';
import { COLORS, FONTS } from '@app/src/ui';
import { FieldGroup } from '@app/src/components/Field';

export const FormWrapper = styled.form`
  width: 550px;
  padding: 0 16px;

  @media(min-width: 480px) {
    padding: 0;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 18px;
`;

export const Error = styled.div`
  width: 100%;
  min-height: 30px;
  font-size: 14px;
  font-family: ${FONTS.ROBOTO_REGULAR};
  color: ${COLORS.ERROR_RED};
`;

export const FieldState = styled(FieldGroup)`
  div {
    flex: 0 1 calc(50% - 10px);
  }
  @media(max-width: 480px) {
    div {
      flex: 1;
    }
  }
`;
